import { UPDATE_SUCCESS } from "../../../constants/actionTypes"

export default ()=> (dispatch)=> {
    
    dispatch({
        type:UPDATE_SUCCESS,  
    })

}